import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "footer bg-dark d-flex align-items-center mt-8" }
const _hoisted_2 = { class: "container text-center pb-5 pt-5" }
const _hoisted_3 = { class: "row d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "col-lg-3 col-md-4 col-12 pb-3 pt-3 d-flex justify-content-md-start justify-content-center" }
const _hoisted_5 = {
  class: "navbar-brand",
  href: "/",
  "aria-label": "Space"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-lg-4 col-md-4 col-12 pb-3 pt-3" }
const _hoisted_8 = { class: "fs-6 text-white" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://mr-apps.com",
  class: "fs-6 text-white"
}, " Credits ", -1)
const _hoisted_10 = { class: "col-lg-3 col-md-4 col-12 pb-3 pt-3" }
const _hoisted_11 = { class: "list-inline mb-0" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "list-inline-item" }
const _hoisted_14 = { class: "btn-group" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("img", {
              class: "navbar-brand-logo",
              src: _ctx.footerLogo,
              style: {"max-height":"40px"},
              alt: "Image Description"
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.t('footer.copyright')) + " - ", 1),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("ul", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socials, (s, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: 'footer-social-' + i,
                class: "list-inline-item"
              }, [
                _createElementVNode("a", {
                  class: "btn btn-ghost-secondary btn-xs btn-icon",
                  href: s.url
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass('bi-' + s.type)
                  }, null, 2)
                ], 8, _hoisted_12)
              ]))
            }), 128)),
            _createElementVNode("li", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_MrUiKitButton, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLanguages = !_ctx.showLanguages)),
                  classes: ['btn btn-soft-secondary btn-xs dropdown-toggle'],
                  ariaExpanded: _ctx.showLanguages
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_15, [
                      _createElementVNode("img", {
                        src: _ctx.getLanguageIcon(_ctx.currentI18nLanguage.locale),
                        class: "avatar avatar-xss avatar-circle me-2"
                      }, null, 8, _hoisted_16),
                      _createElementVNode("span", null, _toDisplayString(_ctx.currentI18nLanguage.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["ariaExpanded"]),
                _createElementVNode("div", {
                  class: _normalizeClass(["dropdown-menu", _ctx.showLanguages && 'show']),
                  style: {"inset":"auto auto 40px -50px","cursor":"pointer"}
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportedLanguages, (s, i) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: 'footer-language-' + i,
                      class: "dropdown-item d-flex align-items-center active",
                      onClick: ($event: any) => (_ctx.switchLanguage(s.locale))
                    }, [
                      _createElementVNode("span", _hoisted_18, [
                        _createElementVNode("img", {
                          src: _ctx.getLanguageIcon(s.locale),
                          class: "avatar avatar-xss avatar-circle me-2"
                        }, null, 8, _hoisted_19),
                        _createElementVNode("span", null, _toDisplayString(s.name), 1)
                      ])
                    ], 8, _hoisted_17))
                  }), 128))
                ], 2)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}